import { format, parse } from 'date-fns';
import i18n from '../i18n';
import { DATE_FORMAT } from '../constants';
import { getDiffInYearsFromNow } from './dates';

export const getUnlockedStepsUpToPayment = (steps) => steps
  .filter((step) => step.n < steps.length)
  .map((s) => s.id);

export const getCoveragesNames = (coverages, fieldNames) => {
  const coverageNames = coverages.reduce(
    (acc, currentValue) => [...acc, currentValue[fieldNames[i18n.language]]],
    [],
  );

  return coverageNames.length ? coverageNames.join(', ') : '-';
};

export const isDisablePaymentFrequencyOption = (step, targetStep) => (
  step ? step.id === targetStep : false
);

export const parseUserDateValues = (user, dateFormat) => {
  const { birthday, passportGiven, passportValidUntil } = user;
  return {
    ...user,
    birthday: birthday && parse(birthday, dateFormat, new Date()),
    passportGiven:
        passportGiven && parse(passportGiven, dateFormat, new Date()),
    passportValidUntil:
        passportValidUntil && parse(passportValidUntil, dateFormat, new Date()),
  };
};

export const formatUserDateValues = (user, dateFormat) => {
  const { birthday, passportGiven, passportValidUntil } = user;
  return {
    ...user,
    birthday: birthday && format(birthday, dateFormat),
    age: getDiffInYearsFromNow(birthday),
    passportGiven: passportGiven && format(passportGiven, dateFormat),
    passportValidUntil: passportValidUntil && format(passportValidUntil, dateFormat),
  };
};

export const separateUserContactInfo = (user) => {
  const {
    phone,
    cellPhone,
    email,
    street,
    streetEn,
    country,
    state,
    cityVillage,
    ...rest
  } = user;
  return {
    ...rest,
    contactInfo: {
      phone,
      cellPhone,
      email,
      street,
      streetEn,
      country,
      state,
      cityVillage,
    },
  };
};

export const mergeUserContactInfo = (user) => {
  const { contactInfo, ...rest } = user;
  return {
    ...rest,
    ...contactInfo,
    // avoid null values for phone and cellphone
    phone: contactInfo.phone || '',
    cellPhone: contactInfo.cellPhone || '',
  };
};

export const convertUserToApiFormat = (user, dateFormat = DATE_FORMAT) => {
  let convertedUser = { ...user };
  convertedUser = formatUserDateValues(convertedUser, dateFormat);
  convertedUser = separateUserContactInfo(convertedUser);
  return convertedUser;
};

export const convertUserToStoreFormat = (user, dateFormat = DATE_FORMAT) => {
  let convertedUser = user;
  convertedUser = parseUserDateValues(convertedUser, dateFormat);
  convertedUser = mergeUserContactInfo(convertedUser);
  return convertedUser;
};
